exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container2d[data-v-0459e6e4],.viewer2d[data-v-0459e6e4]{width:100%;height:100%;position:relative}", ""]);

// exports
